
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFteSum"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fteSumType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FteSumType"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fteSumTarget"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FteSumTarget"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"group"},"name":{"kind":"Name","value":"getGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"fte"},"name":{"kind":"Name","value":"fteSum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fteSumType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fteSumType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fteSumTarget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fteSumTarget"}}}]}}],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFteSumWithDirectWorkforce"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fteSumType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FteSumType"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fteSumTarget"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FteSumTarget"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"group"},"name":{"kind":"Name","value":"getGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"fte"},"name":{"kind":"Name","value":"fteSum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fteSumType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fteSumType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fteSumTarget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fteSumTarget"}}}]}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"directWorkforceFte"},"name":{"kind":"Name","value":"fteSum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fteSumType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fteSumType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fteSumTarget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fteSumTarget"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fteSumFilters"},"value":{"kind":"EnumValue","value":"DIRECT_WORKFORCE_ONLY"}}]}}],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFteSumV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"capacityFteFromSupplyOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"getFteSumV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fteSumTarget"},"value":{"kind":"EnumValue","value":"ALL_MEMBERS"}},{"kind":"Argument","name":{"kind":"Name","value":"capacityFteFromSupplyOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"capacityFteFromSupplyOnly"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"capacityFte"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allocatedFte"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":910}};
    doc.loc.source = {"body":"query getFteSum(\n  $groupId: String!\n  $fteSumType: FteSumType!\n  $fteSumTarget: FteSumTarget!\n) {\n  group: getGroup(groupId: $groupId) {\n    id\n    fte: fteSum(input: { fteSumType: $fteSumType, fteSumTarget: $fteSumTarget })\n  }\n}\n\nquery getFteSumWithDirectWorkforce(\n  $groupId: String!\n  $fteSumType: FteSumType!\n  $fteSumTarget: FteSumTarget!\n) {\n  group: getGroup(groupId: $groupId) {\n    id\n    fte: fteSum(input: { fteSumType: $fteSumType, fteSumTarget: $fteSumTarget })\n    directWorkforceFte: fteSum(\n      input: {\n        fteSumType: $fteSumType\n        fteSumTarget: $fteSumTarget\n        fteSumFilters: DIRECT_WORKFORCE_ONLY\n      }\n    )\n  }\n}\n\nquery getFteSumV2($groupId: ID!, $capacityFteFromSupplyOnly: Boolean) {\n  results: getFteSumV2(\n    groupId: $groupId\n    fteSumTarget: ALL_MEMBERS\n    capacityFteFromSupplyOnly: $capacityFteFromSupplyOnly\n  ) {\n    capacityFte\n    allocatedFte\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getFteSum"] = oneQuery(doc, "getFteSum");
        
        module.exports["getFteSumWithDirectWorkforce"] = oneQuery(doc, "getFteSumWithDirectWorkforce");
        
        module.exports["getFteSumV2"] = oneQuery(doc, "getFteSumV2");
        
